// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Field from '../../components/Field';
import PriceRange from './PriceRange';
import BrandSelect from './BrandSelect';
import ModelsSelect from './ModelsSelect';
import CategorySelect from './CategorySelect';
import TransmissionSelect from './TransmissionSelect';
import { mapFiltersV2 } from '%/utils/filters/usedVehicles/mapFiltersV2';
import {
  incrementFilter,
  setComponentsExhibition,
  setFiltersList,
  setList,
  setMethodApi,
} from '%/stores/Filters/UsedVehicles/FilterV3';
import KeywordField from './KeywordField';
import { parseFiltersStoreStateToComponentState } from '%/utils/filters/usedVehicles/parseFiltersStoreStateToComponentState';
import { resetFilter } from '../../../../../stores/Filters/UsedVehicles/FilterV3';

class SimpleFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterOptionsLoaded: false,
      total: '--',
      filtersList: {
        brands: [],
        models: [],
        categories: [],
        transmissions: [],
        keyword: null,
        min_price: null,
        max_price: null,
      },
    };

    this.filterOptions = {};

    this.filterModelsOptions = this.filterModelsOptions.bind(this);
    this.updateStateFromStore = this.updateStateFromStore.bind(this);
    this.watchStore = this.watchStore.bind(this);
    this.updateFilterList = this.updateFilterList.bind(this);
    this.openAdvancedFilter = this.openAdvancedFilter.bind(this);
  }

  componentDidMount() {
    this.watchStore();
    this.updateMethodApiFromProps();
  }

  filterModelsOptions() {
    const { brands } = this.state.filtersList;
    const { models } = this.filterOptions;

    if (!brands || !models) return [];

    const availableModels = brands.flatMap(
      activeBrand => models[activeBrand] || [],
    );

    const uniqueAvailableModels = Array.from(
      new Set(availableModels.map(model => model.title.toUpperCase())),
    );

    return uniqueAvailableModels.map(title => ({
      title,
      value: title,
    }));
  }

  updateStateFromStore(state) {
    const { total, filtersList } = state;
    const parsedFiltersList =
      parseFiltersStoreStateToComponentState(filtersList);

    this.setState({
      total,
      filtersList: parsedFiltersList,
    });
  }

  watchStore() {
    window.store.UsedVehiclesFilter.watch(
      incrementFilter,
      this.updateStateFromStore,
    );
    window.store.UsedVehiclesFilter.watch(
      setFiltersList,
      this.updateStateFromStore,
    );
    window.store.UsedVehiclesFilter.watch(
      resetFilter,
      this.updateStateFromStore,
    );
    window.store.FilterOptions.watch(state => {
      const { options, loading } = state;

      this.filterOptions = options;

      this.setState({
        filterOptionsLoaded: !loading,
      });
    });
  }

  updateFilterList(filterKey, filterValue) {
    const filter = {
      key: mapFiltersV2[filterKey],
      value: filterValue,
    };

    incrementFilter(filter);
    setList();
  }

  updateMethodApiFromProps() {
    const showSpecialOffers = this.props.showSpecialOffers;

    if (showSpecialOffers) {
      setMethodApi('getUsedModelsSpecialOffers');
    } else {
      setMethodApi('getUsedModels');
    }
  }

  openAdvancedFilter() {
    setComponentsExhibition({
      advancedFilter: true,
    });
  }

  render() {
    const { filtersList } = this.state;

    return (
      <div className="filter-v2__filter-fields">
        <KeywordField
          handleUpdateFilter={this.updateFilterList}
          currentValue={filtersList.keyword}
        />
        <Field
          customClasses="filter-v2__more-filters"
          iconRight="filters"
          handleClick={this.openAdvancedFilter}
        >
          <p className="filter-v2__more-filters-label">
            <span className="only-desktop">Mais </span>filtros
          </p>
        </Field>
        <PriceRange
          handleUpdateFilter={this.updateFilterList}
          currentMinPrice={filtersList.min_price}
          currentMaxPrice={filtersList.max_price}
        />
        <BrandSelect
          options={this.filterOptions.brands}
          activeBrands={filtersList.brands}
          handleUpdateFilter={this.updateFilterList}
        />
        <ModelsSelect
          options={this.filterModelsOptions()}
          hasBrands={filtersList.brands && filtersList.brands.length > 0}
          activeModels={filtersList.models}
          handleUpdateFilter={this.updateFilterList}
        />
        <CategorySelect
          options={this.filterOptions.categories}
          activeCategories={filtersList.categories}
          handleUpdateFilter={this.updateFilterList}
        />
        <TransmissionSelect
          options={this.filterOptions.transmissions}
          activeTransmissions={filtersList.transmissions}
          handleUpdateFilter={this.updateFilterList}
        />
      </div>
    );
  }
}

SimpleFilter.defaultProps = {
  showSpecialOffers: false,
};

SimpleFilter.propTypes = {
  showSpecialOffers: PropTypes.bool,
};

export default SimpleFilter;
